import React from 'react';
import ReactMarkdown from 'react-markdown';

export const SertificationItem = (x) => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const startDate = new Date(x.start);

  let endDate = null;
  let endMonth = null;
  let endYear = null;
  let endResult = null;

  const startMonth = monthNames[startDate.getMonth()];
  const startYear = startDate.getFullYear();

  const startResult = `Issued ${startMonth} ${startYear}`;

  if (x.end) {
    endDate = new Date(x.end);
    endMonth = monthNames[endDate.getMonth()];
    endYear = endDate.getFullYear();

    endResult = ` - Expires ${endMonth} ${endYear}`;
  }

  return (
    <div key={x.id} className="mb-3 education-item">
      <h6 className="font-semibold">{x.key}</h6>
      <ReactMarkdown className="mt-1 text-sm">{x.issued}</ReactMarkdown>
      <div className="flex text-xs text-gray-600 mt-1">
        {startResult}
        {endResult}
      </div>
    </div>
  );
};
